module.exports = __webpack_public_path__ + "static/media/mytoken_admin_login.cdaf0520.png";